import { render, staticRenderFns } from "./GuppywidgetChatBoxHeader.vue?vue&type=template&id=66173a9c"
import script from "./GuppywidgetChatBoxHeader.vue?vue&type=script&lang=js"
export * from "./GuppywidgetChatBoxHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports